import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '../../theme';
import useTextBoxStyles from './TextBox.Styles';
export const TextBox = ({ size = 'm', disabled = false, label, sx, ...props }) => {
    const theme = useTheme();
    const styles = useTextBoxStyles({
        ...props,
        theme
    });
    return (_jsxs("label", { className: styles.container, style: sx, children: [label ? _jsx("span", { className: styles.label, children: label }) : null, _jsx("textarea", { className: `${styles.base} ${disabled ? styles.disabled : ''} ${size === 'xl' ? styles.xl : ''}`, disabled: disabled, style: sx, ...props })] }));
};
export default TextBox;
